import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";
import SEO from "@/components/SEO";
import BreadcrumbSchema from "@/components/BreadcrumbSchema";
import { Leaf, ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import bannerImage from "@/assets/banner-flour.jpg";

const Farine = () => {
  const products = [
    {
      name: "Prodotti del territorio",
      description: "Farine e cereali del territorio marchigiano e umbro",
      features: ["Territorio umbro e toscano", "Varietà locali", "Produzione artigianale", "Qualità garantita", "Macinazione a pietra", "Grani selezionati", "Farine biologiche", "Semole e cereali"]
    }
  ];

  return (
    <div className="min-h-screen">
      <SEO
        title="Farine Biologiche Macinate a Pietra - Umbria"
        description="Farine macinate a pietra, biologiche e artigianali del territorio umbro e toscano. Grani selezionati, semole e cereali. Produzione locale."
        canonical="/prodotti/farine"
        type="product"
      />
      <BreadcrumbSchema items={[
        { name: "Home", url: "/" },
        { name: "Farine", url: "/prodotti/farine" }
      ]} />
      <Navbar />

      {/* Hero Banner Section */}
      <section className="relative h-[450px] md:h-[500px] overflow-hidden pt-24 md:pt-28">
        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${bannerImage})` }}
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

        {/* Content */}
        <div className="relative container mx-auto px-4 h-full flex flex-col justify-start md:justify-center pt-2 md:pt-0">
          <Link to="/#prodotti" className="mb-6 w-fit">
            <Button variant="outline" className="bg-white/10 text-white border-white/30 hover:bg-white/20 backdrop-blur-sm">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Torna ai prodotti
            </Button>
          </Link>

          <div className="max-w-4xl">
            <div className="icon-wrapper mb-6 w-16 h-16 text-white hidden md:flex items-center justify-center">
              <Leaf className="w-12 h-12" />
            </div>
            <h1 className="text-4xl md:text-5xl font-heading font-bold mb-6 text-white">
              Farine e Cereali
            </h1>
            <p className="text-xl text-white/90 max-w-3xl">
              Farine di altissima qualità del territorio. Macinazione a pietra
              e grani selezionati per prodotti da forno dal sapore autentico.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-7xl mx-auto">
            {products.map((product, index) => (
              <div
                key={index}
                className="bg-card rounded-2xl p-8 border border-border card-hover w-full"
              >
                <h3 className="text-2xl font-heading font-semibold mb-4">
                  {product.name}
                </h3>
                <p className="text-muted-foreground mb-6">
                  {product.description}
                </p>
                <ul className="space-y-2 grid sm:grid-cols-2 lg:grid-cols-4 gap-x-8 gap-y-2">
                  {product.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <span className="text-primary mr-2 flex-shrink-0">✓</span>
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 p-6 bg-amber-50 dark:bg-amber-950/20 border border-amber-200 dark:border-amber-800 rounded-xl max-w-4xl mx-auto">
            <h3 className="text-xl font-semibold mb-2 text-amber-900 dark:text-amber-100">
              🌾 Tradizione e qualità
            </h3>
            <p className="text-amber-800 dark:text-amber-200">
              Le nostre farine rappresentano l'eccellenza della tradizione molitoria del territorio.
              Ogni sacco porta con sé la storia e l'esperienza di generazioni di esperti mugnai.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-primary/5">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-heading font-bold mb-4">
            Scopri la differenza
          </h2>
          <p className="text-xl text-muted-foreground mb-8 max-w-2xl mx-auto">
            Vieni a trovarci per scoprire l'intera gamma di farine e cereali
            e ricevere consigli per le tue ricette.
          </p>
          <Link
            to="/#contatti"
            className="inline-block px-8 py-3 bg-primary text-primary-foreground rounded-lg hover:opacity-90 transition-opacity"
          >
            Contattaci
          </Link>
        </div>
      </section>

      <ContactSection />
      <Footer />
    </div>
  );
};

export default Farine;
